export default {
	setLogin(state, payload) {
		payload.loginTime = Date.now();
		localStorage.setItem('login', JSON.stringify(payload));
		state.login = payload;
	},
	setLoading(state, payload) {
		state.loading = payload;
	},
	clearLogin(state, payload) {
		localStorage.setItem('login', null);
	},
	setUnauthorized(state, payload) {
		state.unauthorized = payload;
	},
	setErrBlock(state, payload) {
		state.showErrBlock = payload;
	},
	setSessionExpired(state, payload) {
		state.sessionExpired = payload;
	},
	setTimeForOtp(state, payload) {
		localStorage.setItem('timeLeft', payload);
		state.timeLeft = payload;
	},
	setEScript(state, payload) {
		state.eScript = payload;
	},
	setPatientInfo(state, payload) {
		state.patientInfo = payload;
	},
	setGroupRequestDetails(state, payload) {
		localStorage.setItem('groupRequestDetails', JSON.stringify(payload));
		state.groupRequestDetails = payload;
	},
	setFcmToken(state, payload) {
		localStorage.setItem('fcmToken', JSON.stringify(payload));
		state.fcmToken = payload;
	},
	setDeviceId(state, payload) {
		localStorage.setItem('deviceId', JSON.stringify(payload));
		state.deviceId = payload;
	},
	setGroupRequestId(state, payload) {
		localStorage.setItem('groupRequestId', JSON.stringify(payload));
		state.groupRequestId = payload;
	},
	setShowAlert(state, payload) {
		state.showAlert = payload;
	},
	setFromGroupRequests(state, payload) {
		state.fromGroupRequests = payload;
	},
	setScriptRequestDetails(state, payload) {
		localStorage.setItem('scriptRequestDetails', JSON.stringify(payload));
		state.scriptRequestDetails = payload;
	},
	setNotificationStatus(state, payload) {
		state.notificationStatus = payload;
	},
	setName(state, payload) {
		localStorage.setItem("phstname",payload)
		state.name = payload;
	},
	setReceivedMessage(state, payload) {
		state.receivedMessage = JSON.stringify(payload);
	},
	setReceived(state,payload){
		state.received=JSON.stringify(payload);
	},
	setFromPath(state,payload){
		localStorage.setItem("fromPath",payload)
		state.frompath=payload
	},
	setPharmacistData(state,payload){
		localStorage.setItem("pDetails",JSON.stringify(payload))   // pharmacist details
		state.pharmacyData=payload
	},
	setChatIdPayload(state,payload){
        state.chatIdPayload=payload;
    },

}